import { definePropertyId } from "./PropertyId";

export const PID_TEXT_CONTENT = definePropertyId('textContent');
export const PID_FONT_SIZE = definePropertyId('fontSize');
export const PID_RECT_WIDTH = definePropertyId('rectWidth');
export const PID_RECT_HEIGHT = definePropertyId('rectHeight');
export const PID_CIRCLE_RADIUS = definePropertyId('circleRadius');
export const PID_SHOW_AREA_TEXT = definePropertyId('showAreaText');
export const PID_EXTRUSION_DEPTH = definePropertyId('extrusionDepth');
export const PID_SHOW_VOLUME = definePropertyId('showVolume');
